import styled from 'styled-components'

export const CommentDateWrapper = styled.span``
